import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { dispatch } from '../../../store';
import { changeSelectedMembers } from '../../../store/slices/add-team-members.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpAddTeamMembers = () => {
    const organizationApi = useContainer(OrganizationApi);
    const { t } = useTranslation('newNotifications');
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (id: string, userSubs: string[]) => {
        const { exec, abort } = organizationApi.addTeamMembers({
            params: { id },
            body: { userSubs },
            onSuccess: _ => {
                dispatch(changeSelectedMembers());
                toastHandler.push('success', t('team.addTeamMemberTitle'), t('team.addTeamMember_Success'));
                navigate(0);
            },
            onError: () => {
                toastHandler.push('error', t('team.addTeamMemberTitle'), t('team.addTeamMember_Error'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpAddTeamMembers;
